import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { ConditionalField } from '@src/orders/PermitFormSections/ConditionalField';
import { ControllerFormTextInput } from '@src/orders/PermitFormSections/ControllerFormTextInput';
import { DriverInformationInputsSchema } from '@src/orders/schemas/DriverInformationInputsSchema';
import {
  DriverEmailField,
  DriverIdField,
  DriverLicenseNumberField,
  DriverNameField,
  DriverPhoneField,
} from '@src/permitField/DriverInformationFields';
import type { Control } from 'react-hook-form';
import type * as yup from 'yup';

const _addForm = DriverInformationInputsSchema.omit([DriverIdField.fieldName]);

interface Props {
  control: Control<yup.InferType<typeof _addForm>>;
  readOnly?: boolean;
  fields?: string[];
}

export const DriverForm = ({ control, readOnly, fields }: Props) => {
  const showEmailInput =
    !fields || fields?.includes(DriverEmailField.fieldName);
  const showPhoneInput =
    !fields || fields?.includes(DriverPhoneField.fieldName);

  return (
    <Stack direction="column" gap={theme.spacing['8']}>
      <ConditionalField fields={fields} conditions={DriverNameField.fieldName}>
        <ControllerFormTextInput
          disabled={readOnly}
          control={control}
          fieldName={DriverNameField.fieldName}
        />
      </ConditionalField>
      {(showEmailInput || showPhoneInput) && (
        <Stack direction="row" gap={theme.spacing['8']}>
          <ConditionalField
            fields={fields}
            conditions={DriverEmailField.fieldName}
          >
            <ControllerFormTextInput
              disabled={readOnly}
              control={control}
              fieldName={DriverEmailField.fieldName}
            />
          </ConditionalField>
          <ConditionalField
            fields={fields}
            conditions={DriverPhoneField.fieldName}
          >
            <ControllerFormTextInput
              disabled={readOnly}
              control={control}
              fieldName={DriverPhoneField.fieldName}
            />
          </ConditionalField>
        </Stack>
      )}
      <ConditionalField
        fields={fields}
        conditions={DriverLicenseNumberField.fieldName}
      >
        <ControllerFormTextInput
          disabled={readOnly}
          control={control}
          fieldName={DriverLicenseNumberField.fieldName}
        />
      </ConditionalField>
    </Stack>
  );
};
